<template>
  <div>
    <div class="add-address-top">
      <div class="input-box">
        <div class="text">收货人</div>
        <div class="box">
          <input type="text" v-model="addressInfo.consigneeName" maxlength="10" placeholder="请填写收货人姓名">
        </div>
      </div>
      <div class="input-box">
        <div class="text">手机号码</div>
        <div class="box">
          <input type="number" maxlength="11" v-model="addressInfo.consigneeMobile" @input="inputChange($event, 'phone')" placeholder="请填写收货人手机号">
        </div>
      </div>
      <div class="input-box">
        <div class="text">所在地区</div>
        <div class="box">
          <input type="text" placeholder="请选择地区" v-model="address" readonly @click="addressShow = true">
        </div>
      </div>
      <div class="input-box">
        <div class="text">详细地址</div>
        <div class="box">
          <input type="text" v-model="addressInfo.detailAddress" placeholder="街道、楼牌号">
        </div>
      </div>
      <div class="input-box" style="border: none">
        <div class="text" style="width: 260px">
          <div>设为默认地址</div>
          <div class="">提醒：每次下单会默认该地址</div>
        </div>
        <div class="box" style="text-align: right">
<!--          <van-switch v-model="checked" />-->
          <img src="@/assets/img/my_icon_notset_nor@2x.png" class="notset" v-if="!addressInfo.isDefault" alt="" @click="defaultChoose">
          <img src="@/assets/img/my_icon_notset_sel@2x.png" class="notset" v-else alt="" @click="defaultChoose">
        </div>
      </div>

    </div>
    <div class="mask" @click="c_cancel" v-if="addressShow"></div>
    <van-area title="选择地区" :area-list="areaList" v-if="addressShow" :value="addressInfo.districtCode" @cancel="c_cancel" @confirm="c_confirm" @change="c_change"  item-height="0.8rem" />
<!--    <div class='btn-fixed' style='box-shadow:none;'>-->
<!--      <div class='btn' @click='save'>保存</div>-->
<!--&lt;!&ndash;      <div class='btn delete'>删除</div>&ndash;&gt;-->
<!--    </div>-->
    <div class="common-ocupie"></div>
    <div class='common-box' style="background: #fff">
      <div class='common-btn delPart' @click='deleteAddress'>删除</div>
      <div class='common-btn' @click='save'>完成</div>
    </div>
  </div>
</template>
<script>
import areaList from 'utils/Area'
import Cookies from 'js-cookie'
export default {
  name: 'shopCart',
  components: {

  },
  data () {
    return {
      checked: true,
      // areaList: {
      //   province_list: {
      //     110000: '北京市',
      //     120000: '天津市'
      //   },
      //   city_list: {
      //     110100: '北京市',
      //     110200: '县',
      //     120100: '天津市',
      //     120200: '县'
      //   },
      //   county_list: {
      //     110101: '东城区',
      //     110102: '西城区',
      //   }
      // },
      areaList: areaList,
      addressShow: false,
      address: "",
      addressInfo: {
        consigneeName: '',
        consigneeMobile: '',
        province: '',
        city: '',
        district: '',
        detailAddress: '',
        isDefault: 0,
        districtCode: ''
      },
      id: ''
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#fff;');
  },
  created () {
    this.id = this.$route.query.id;
    if (this.id) {
      document.title = "编辑收货地址"
      this.initData()
    } else {
      document.title = "新增收货地址"
    }
    // this.getRegions("-1", 1)
  },
  mounted () {
    console.log(this.addressInfo.districtCode)
  },
  methods: {
    inputChange (e, type) {
      var val = e.target.value;
      if (val.length < 12) {
        val.replace(/\D/g, '')
        this.addressInfo.consigneeMobile = val;
        this.$forceUpdate()
      } else {
        var temp = val.slice(0, 11)
        this.addressInfo.consigneeMobile = temp;
        this.$forceUpdate()
      }
    },
    initData () {
      var that = this;
      var param = {
        service: "appagg",
        query: { id: this.id }
      }
      that.$api.getSingleAddress(param).then(res => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.addressInfo = res.data.result;
            that.address = res.data.result.province + res.data.result.city + res.data.result.district;
          }
        }
      })
    },
    deleteAddress () {
      var that = this;
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否确定要删除'
      })
        .then(() => {
          var param = {
            service: "appagg",
            query: { id: this.id }
          }
          that.$api.deleteAddress(param).then(res => {
            if (res) {
              if (res.data.basis.status === 200) {
                this.$toast("删除成功");
                var choiceAddressId = Cookies.set("choiceAddressId");
                if (choiceAddressId) {
                  if (choiceAddressId == that.id) {
                    Cookies.remove("choiceAddressId");
                  }
                }
                setTimeout(function () {
                  that.$router.replace({ path: '/addressManage', query: {} })
                }, 1000)
              }
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    save () {
      var that = this;
      if (!this.addressInfo.consigneeName) {
        this.$toast("请填写收货人");
        return false
      }
      if (!this.addressInfo.consigneeMobile) {
        this.$toast("请填写收货人手机");
        return false
      }
      if (!this.address) {
        this.$toast("请填写选择所在地区");
        return false
      }
      if (!this.addressInfo.detailAddress) {
        this.$toast("请填写详细地址");
        return false
      }
      var param = {
        service: "appagg",
        query: this.addressInfo
      }
      if (this.id) {
        this.$api.updateAddress(param).then(res => {
          if (res) {
            if (res.data.basis.status === 200) {
              this.$toast("修改成功");
              setTimeout(function () {
                that.$router.replace({ path: '/addressManage', query: {} })
              }, 1000)
            }
          }
        })
      } else {
        this.$api.addAddress(param).then(res => {
          if (res) {
            if (res.data.basis.status === 200) {
              this.$toast("添加成功");
              setTimeout(function () {
                that.$router.replace({ path: '/addressManage', query: {} })
              }, 1000)
            }
          }
        })
      }
    },
    c_cancel () {
      this.addressShow = false
    },
    c_confirm (array) {
      this.address = array[0].name + array[1].name + array[2].name;
      console.log(this.address);
      this.addressShow = false;
      this.addressInfo.province = array[0].name;
      this.addressInfo.city = array[1].name;
      this.addressInfo.district = array[2].name;
      this.addressInfo.districtCode = array[2].code;
    },
    c_change (e, i, n) {
    },
    linkPay () {

    },
    addAddress () {
    },
    defaultChoose () {
      this.addressInfo.isDefault = !this.addressInfo.isDefault;
    }
  }
}
</script>

<style scoped lang="less">
  .notset{
    width: 96px;
    height: 96px;
  }
  /deep/ .van-picker{
    position: absolute;
    width: 100%;
    bottom: 0px;
    height: 7rem;
  }
  .delPart{
    background: #fff;
    border: 2px solid #FF3E29;
    color: #F46F60;
  }
  .common-btn{
    width: 300px;
  }
  /deep/ .van-picker__columns{
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    z-index: 10000;
  }
.btn-fixed div{
  height: 90px;
  line-height: 90px;
  border-radius: 45px;
  color: #fff;
  text-align: center;
  background-color: #30ADFD;
  display: block;
  margin: 0 25px;
  font-size: 34px;
}
.btn-fixed{
  background: #ffffff;
  position: fixed;
  width: 100%;
  padding: 28px 0;
  left: 0;
  bottom: 0;
  z-index: 9;
  box-shadow:0px -3px 4px 0px rgba(181,180,180,0.31);
}
.tips{
  font-size: 32px;
  color: red;
  padding-bottom: 30px;
}
.box{
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 28px;
  color: #333;
  line-height: 52px;
}
.box input{
  color: #333;
  font-size: 30px;
  height: 50px;
  min-height: inherit;
  line-height: 50px;
  /*margin-top: 4px;*/
  width: 100%;
}
.text{
  font-size: 30px;
  color: #1F1F1F;
  line-height: 52px;
  width: 158px;
}
.add-address-top{
  background-color: #fff;
  padding: 0 25px;
}
.input-box{
  border-bottom: 1px solid #F2F1F1;
  display: -webkit-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 40px 0;
  align-items: center;
}
</style>
